import { BillingPlanDto, BillingPlanListType, BillingSubscriptionDto } from '@shared/core/billing'
import { GetProfileResponseDto } from '@shared/core/users'
import type { UseQueryOptions } from 'react-query'

export type UsePlanDataOptions = {
  subscriptionOptions?: UseQueryOptions<BillingSubscriptionDto>
  subscriptionPlansOptions?: UseQueryOptions<BillingPlanDto[]>
  profileOptions?: UseQueryOptions<GetProfileResponseDto>
  freePlanOptions?: UseQueryOptions<BillingPlanDto>
  isYearly?: boolean
  type?: BillingPlanListType
}

export type BillingType = 'month' | 'year' | 'day' | 'week'

export type BillingTypes = {
  shortInterval: BillingType
  longInterval: BillingType
}

export enum SubscriptionStatus {
  active = 'active',
  trialing = 'trialing',
  past_due = 'past_due',
  paused = 'paused',
  deleted = 'deleted',
}
